import sedanImage from '../img/car1.jpg';
import suvImage from '../img/car2.jpg';
import minivanImage from '../img/car3.jpg';
import fourByFourImage from '../img/car4.jpg';
// car catagories
export const carCategories = [
    { value: "", label: "" },
    { value: "Luxury", label: "Luxury" },
    { value: "Compact SUV", label: "Compact SUV" },
    { value: "full_size_suv", label: "Full-Size SUV" },
    { value: "economy", label: "Economy" },
    { value: "compact", label: "Compact" },
    { value: "convertible", label: "Convertible" },
    { value: "sports", label: "Sports Car" },
    { value: "pickup", label: "Pickup Truck" },
    { value: "Minivan", label: "Minivan" },
    { value: "electric", label: "Electric" },
  ];
  // car data with catagory


  export const carRentalData = [
    {
      id: "category-1",
      categoryName: "Luxury",
      categoryImage: sedanImage,
      categoryDescription:
        "Vehicles offering premium interiors, high performance, and advanced features for a luxurious driving experience.",
      cars: [
        {
          id: "car-1-1",
          name: "BMW 5 Series",
          model: "2024",
          transmission: "Automatic",
          description:
            "Combines style, technology, and performance for business and leisure.",
          carryCapacity: "5 passengers, 4 bags",
          mainImage: sedanImage,
          gallery: [sedanImage, suvImage, minivanImage],
          dailyRate: 150, // in USD
        },
        {
          id: "car-1-2",
          name: "Audi A6",
          model: "2023",
          transmission: "Automatic",
          description:
            "Luxury sedan with cutting-edge infotainment and smooth handling.",
          carryCapacity: "5 passengers, 4 bags",
          mainImage: suvImage,
          gallery: [suvImage, fourByFourImage, minivanImage],
          dailyRate: 140, // in USD
        },
        // Add 3 more cars here
      ],
    },
    {
      id: "category-2",
      categoryName: "Compact SUV",
      categoryImage: suvImage,
      categoryDescription:
        "Small SUVs offering excellent fuel efficiency and a comfortable ride for smaller families.",
      cars: [
        {
          id: "car-2-1",
          name: "Toyota RAV4",
          model: "2023",
          transmission: "Automatic",
          description:
            "Versatile compact SUV with off-road capabilities.",
          carryCapacity: "5 passengers, 3 bags",
          mainImage: suvImage,
          gallery: [suvImage, minivanImage, fourByFourImage],
          dailyRate: 90, // in USD
        },
        {
          id: "car-2-2",
          name: "Kia Sportage",
          model: "2023",
          transmission: "Automatic",
          description:
            "Compact SUV with cutting-edge safety and infotainment features.",
          carryCapacity: "5 passengers, 3 bags",
          mainImage: minivanImage,
          gallery: [minivanImage, fourByFourImage, sedanImage],
          dailyRate: 85, // in USD
        },
        // Add 3 more cars here
      ],
    },
    {
      id: "category-3",
      categoryName: "Minivan",
      categoryImage: minivanImage,
      categoryDescription:
        "Spacious vehicles designed for families and group travel with ample room for passengers and luggage.",
      cars: [
        {
          id: "car-3-1",
          name: "Honda Odyssey",
          model: "2023",
          transmission: "Automatic",
          description:
            "Family-friendly minivan with advanced safety features.",
          carryCapacity: "7 passengers, 4 bags",
          mainImage: minivanImage,
          gallery: [minivanImage, sedanImage, suvImage],
          dailyRate: 100, // in USD
        },
        {
          id: "car-3-2",
          name: "Toyota Sienna",
          model: "2023",
          transmission: "Automatic",
          description:
            "Stylish minivan with hybrid powertrain options.",
          carryCapacity: "7 passengers, 4 bags",
          mainImage: fourByFourImage,
          gallery: [fourByFourImage, sedanImage, minivanImage],
          dailyRate: 110, // in USD
        },
        // Add 3 more cars here
      ],
    },
    {
      id: "category-4",
      categoryName: "4x4",
      categoryImage: fourByFourImage,
      categoryDescription:
        "Rugged vehicles built for off-road adventures and tough terrains.",
      cars: [
        {
          id: "car-4-1",
          name: "Jeep Wrangler",
          model: "2024",
          transmission: "Manual",
          description:
            "Iconic off-road vehicle with superior capabilities.",
          carryCapacity: "5 passengers, 2 bags",
          mainImage: fourByFourImage,
          gallery: [fourByFourImage, suvImage, sedanImage],
          dailyRate: 120, // in USD
        },
        {
          id: "car-4-2",
          name: "Ford Bronco",
          model: "2024",
          transmission: "Automatic",
          description:
            "Adventure-ready SUV for challenging terrains.",
          carryCapacity: "5 passengers, 3 bags",
          mainImage: suvImage,
          gallery: [suvImage, fourByFourImage, minivanImage],
          dailyRate: 125, // in USD
        },
        // Add 3 more cars here
      ],
    },
  ];
  
  


